<app-loader *ngIf="loaderService.loader | async"></app-loader>
<div class="main">
  <div class="main-container">
    <router-outlet></router-outlet>
  </div>
</div>
